<template>
  <div class="form-body">
    <div class="row">
      <div class="form-holder">
        <div class="form-content">
          <div class="form-items" style="margin-top: 0%;">
            <div>
              <div class="form-row newDesign" style="width: 100%" v-if="acceptance" >
                <span class="logo" style="width: 100%;" v-html="logos"></span>
                <span class="logo" style="width: 100%;" v-html="REGISTERATION_SUCCESS_ICON"></span><br>
                  <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>{{successmsg}}!</strong></p>
                  <br><br>
              </div>
              <div class="form-row newDesign" style="width: 100%" v-if="!acceptance">
                <span class="logo" style="width: 100%;" v-html="logos"></span><br>
                <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>You are shortlisted by {{ orgdata.org_name }}</strong></p>
                  <br><br>
                  <table class="table acstable">
                    <tr>
                      <td><b>Organization Name</b> </td>
                      <td>{{orgdata.org_name}}</td>
                    </tr>
                    <tr>
                      <td><b>Industry</b> </td>
                      <td>{{orgdata.type}}</td>
                    </tr>
                    <tr>
                      <td><b>Location</b> </td>
                      <td>
                        {{orgdata.city + ', ' + orgdata.state + ', ' + orgdata.country}}
                      </td>
                    </tr>
                    <tr>
                      <td><b>Job Title</b> </td>
                      <td>{{postData.job_title}}</td>
                    </tr>
                    <tr>
                      <td><b>Job Description</b> </td>
                      <td>{{postData.job_comments}}</td>
                    </tr>
                    <tr>
                      <td><b>Required Experience</b> </td>
                      <td>
                        <span v-if="postData.year_of_experience != 0 || postData.month_of_experience != 0">
                          {{postData.year_of_experience + ' Years' + postData.month_of_experience + ' months'}}
                        </span>
                        <span v-if="postData.year_of_experience == 0 && postData.month_of_experience == 0">
                          {{"Fresher"}}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td><b>Must have skills</b> </td>
                      <td>{{postData.primarySkillName}}</td>
                    </tr>
                    <tr>
                      <td><b>Annual CTC</b> </td>
                      <td>{{postData.min_ctc + ' - ' + postData.max_ctc}}</td>
                    </tr>
                  </table>
                  <div style="text-align: center;width: 100%;">
                    <button class="btn btn-success" @click="shortlistResponse('accept')">Accept</button> &nbsp; <button class="btn btn-danger" @click="shortlistResponse('reject')">Decline</button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { REGISTERATION_SUCCESS, logo } from '../shared/svg'
import { BaseURLV3 } from '../shared/classes'
import axios from 'axios'
import momentsone from 'moment-timezone'

export default {
  name: 'RequestShortlistV3',
  data () {
    return {
      REGISTERATION_SUCCESS_ICON: REGISTERATION_SUCCESS,
      logos: logo,
      timezone: momentsone.tz.guess(),
      timezonetype: 'IST',
      candidate_id: null,
      schedule_id: this.$route.params.sid,
      post_id: null,
      postData: null,
      acceptance: false,
      orgdata: null,
      scheduleData: null
    }
  },
  created () {
    this.getScheduleDetails()
  },
  methods: {
    getScheduleDetails () {
      axios
        .get(BaseURLV3 + '/interviewer/' + this.schedule_id + '/meeting')
        .then(response => {
          if (response.data.success) {
            this.scheduleData = response.data.schedule
            this.post_id = this.scheduleData.post_id
            if (this.scheduleData.status === 'Shortlisted' && this.scheduleData.sub_status === 'Shortlist Initiated') {

            } else {
              this.acceptance = true
              if (this.scheduleData.status === 'Shortlisted' && this.scheduleData.sub_status === 'Rejected') {
                this.successmsg = 'You have declined the shortlist request.'
              } else if (this.scheduleData.status === 'Shortlisted' && this.scheduleData.sub_status === 'Accepted') {
                this.successmsg = 'You have already accepted the shortlist request.'
              }
            }
            this.getPostDetails()
          }
        })
    },
    getPostDetails () {
      axios
        .get(BaseURLV3 + '/org/post/' + this.post_id)
        .then(response => {
          if (response.data.success) {
            this.postData = response.data.post
            this.postData.primarySkillName = ''
            for (var j = 0; j < this.postData.p_p_skill.length; j++) {
              if (this.postData.primarySkillName === '') {
                this.postData.primarySkillName = this.postData.p_p_skill[j].skill.name
              } else {
                this.postData.primarySkillName = this.postData.primarySkillName + ', ' + this.postData.p_p_skill[j].skill.name
              }
            }
            this.getOrgDetails(this.postData.org_id)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getOrgDetails (id) {
      axios.get(BaseURLV3 + '/org/' + id + '/details', this.config).then(response => {
        if (response.data.success) {
          this.orgdata = response.data.org
        }
        console.log('done')
      }).catch(e => {
      })
    },
    shortlistResponse (resp) {
      var data = {
        schedule_id: this.schedule_id,
        action: resp
      }
      const mainurl = BaseURLV3 + '/interviewer/candidate/req_shortlist'
      axios.post(`${mainurl}`, data).then(response => {
        console.log('response', response)
        this.acceptance = true
        this.successmsg = response.data.msg
      })
    }
  }
}
</script>

<style scoped>
.form-holder {
  margin-left: 0px;
  width: 100%;
}
.success-text-align {
  width: 100%;
  font-weight: 400;
}
.success-sub-text-align {
  width: 100%;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-content {
    width: 100%;
}
.form-content p {
  line-height: 5px;
}
.logo-size {
  width: 50%;
}

.table, th, td {
  /* border: 1px solid #252424b8; */
  background-color: rgb(241, 240, 237);
  vertical-align: top;
}
td {
  padding-top: 10px;
  font-size: 12px;
}
.acstable td {
  width: 60%;
  padding-left: 11px;
  text-align: left;
}
</style>
